import './ContactCustomerCare.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CustomerCareSection from './components/CustomerCareSection';
var ContactCustomerCare = function ContactCustomerCare(props) {
  var fields = props.fields,
    params = props.params,
    rtl = props.rtl;
  var item = fields.data.item;
  if (!item) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement(CustomerCareSection, {
    item: item
  }));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    anchorUrlParameter = _ref.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default ContactCustomerCare;
var commonStyles = "c1l3gqb7";
var ltrStyles = "l1f05rhd";
var rtlStyles = "r1cca78y";